@if(env?.inMaintenanceMode) {
    <!-- Maintenance mode -->
    <span class="cloud-env-in-maintenance-mode" [title]="env?.statusMessage || ''">Under maintenance</span>
}
@else {
    <!-- Enabled environments -->
    <span *ngIf="env?.isEnabled && env?.isAvailable" class="cloud-env-available" [title]="env?.statusMessage || ''">Available</span>
    <span *ngIf="env?.isEnabled && !env?.isAvailable" class="cloud-env-unavailable" [title]="env?.statusMessage || ''">Unavailable</span>

    <!-- Disabled environments -->
    <span *ngIf="!env?.isEnabled && env?.isAvailable" class="cloud-env-available-internal" [title]="env?.statusMessage || ''">Available (DevOps)</span>
    <span *ngIf="!env?.isEnabled && !env?.isAvailable" class="cloud-env-unavailable-internal" [title]="env?.statusMessage || ''">Unavailable (DevOps)</span>
}